
import React from "react";
import ReactDOM from "react-dom/client";
import "./App.css";
import App from "./App";
import { DataProvider } from './DataContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <DataProvider>
      <App />
    </DataProvider>
);

serviceWorkerRegistration.register();
